/* prettier-ignore */
export const content = {
  'designer.components.manager.create-code-component': 'Generate with AI',
  'designer.components.manager.create-code-component-from-template': 'Create from template',
  'designer.components.settings.properties.custom-components-safe-mode-note.action': 'Enable code components',
  'designer.components.settings.properties.vibe-component-ai-note.title': 'Customize props with AI',
  'designer.components.settings.properties.vibe-component-ai-note.body': 'Tell the AI Assistant what to change \u2014 content, color, visibility, and more.',
  'designer.components.settings.properties.vibe-component-ai-note.action': 'Ask the AI Assistant',
  'designer.components.navigator.vibe-component-structure-note.body': 'Use the AI Assistant to modify component structure.',
  'designer.components.navigator.vibe-component-structure-note.action': 'Ask AI Assistant',
  'designer.components.navigator.code-component-empty-state': 'Code component is loading...',
  'designer.components.code-component.unlink-error': 'Cannot unlink code components',
  'designer.components.style-variants.code-component.description':
    'Use the AI Assistant to modify code component variants.',
  'designer.components.libraries.validation.code-components-require-site-plan':
    'Code components require a Premium Site plan or higher',
  'designer.components.code-component.upgrade-banner.body':
    "You'll need a Premium Site plan or higher to publish code components.",
  'designer.components.code-component.upgrade-banner.upgrade-plan-action':
    'Upgrade plan',
  'designer.components.code-component.upgrade-banner.upgrade-now-action':
    'Upgrade now',
  'designer.components.code-component.upgrade-banner.publish-body':
    "Code components won't be included when you publish. Upgrade to a Premium Site plan or higher to publish them.",
  'designer.components.code-component.upgrade-banner.publish-modal-body':
    'Upgrade to a Premium Site plan or higher to publish code components.',
  'designer.components.libraries.upgrade-to-install-code-libraries-banner': 'Upgrade your site to a Premium Site plan or higher to install and use code components.',
  'designer.components.libraries.upgrade-to-install-code-libraries-action': 'See plans',
  'designer.components.code-component-read-only':
    'Code components can only be edited in the source code',
  'designer.components.libraries.code-component': 'code component',
  'designer.components.settings.properties.create-disabled-code-component':
    'To add new properties, use the AI assistant',
  'designer.components.settings.properties.create-in-group-disabled-code-component':
    'To add properties to this group, use the AI assistant',
  'designer.components.settings.properties.modify-disabled-code-component':
    'To modify properties, use the AI assistant',
  'designer.components.manager.edit-component.modify-disabled-code-component':
    'To modify the name, group, and description, use the AI assistant',
  'designer.components.code-component.compilation-errors-note':
    "AI code components can't be displayed due to errors.",
  'designer.components.code-component.credit-usage.popover-title':
    'AI credit usage',
  'designer.components.code-component.credit-usage.remaining':
    '{{percentage}}% remaining',
  'designer.components.code-component.credit-usage.remaining-of-total':
    '{{remaining}}/{{granted}} credits remaining',
  'designer.components.code-component.credit-usage.credits-billed-to':
    'Credits billed to {{workspace}}',
  'designer.components.code-component.credit-usage.credits-billed-to-tooltip':
    'As a guest, your AI Credit usage is billed to your connected Freelancer or Agency workspace.',
  'designer.components.code-component.credit-usage.credits-billed-to-host-tooltip':
    '{{workspace}} has authorized you to spend their AI credits. Your AI usage on this site will be billed to their workspace.',
  'designer.components.code-component.credit-usage.next-credits-on':
    'Next credits on {{date}}',
  'designer.components.code-component.credit-usage.view-full-usage':
    'View full usage',
  'designer.components.code-component.credit-usage.add-credits':
    'Add credits',
  'designer.components.code-component.credit-usage.used-50-percent':
    "You've used 50% of your Workspace's AI credits.",
  'designer.components.code-component.credit-usage.used-75-percent':
    "You've used 75% of your Workspace's AI credits.",
  'designer.components.code-component.credit-usage.used-90-percent':
    "You've used 90% of your Workspace's AI credits.",
  'designer.components.code-component.credit-usage.exceeded-limit':
    'Your Workspace is out of AI credits',
  'designer.components.code-component.credit-usage.exceeded-limit-body':
    'Add credits or wait for your credits to renew in {{days}}.',
  'designer.components.code-component.credit-usage.exceeded-limit-body-member':
    'A Workspace owner or admin needs to add credits, or wait for your credits to renew in {{days}}.',
  'designer.components.code-component.credit-usage.out-of-credits-toast-body':
    'Add credits or wait for them to renew in {{days}}.',
  'designer.components.code-component.credit-usage.out-of-credits-toast-body-member':
    'Contact an admin for {{workspaceName}} to add credits or wait for them to renew in {{days}}.',
  'designer.components.code-component.credit-usage.soft-limit-exceeded':
    'Your Workspace has exceeded its AI credits. Your account team will reach out about adding more.',
  'designer.components.code-component.credit-usage.legacy-guest-blocked-title':
    'Update your guest access to use AI Credits',
  'designer.components.code-component.credit-usage.legacy-guest-blocked-body':
    'You must update to the latest version of guest access in order to consume AI credits in this workspace.',
  'designer.components.code-component.credit-usage.legacy-guest-blocked-action':
    'Update guest access',
} as const;
